// extracted by mini-css-extract-plugin
export default {"documents":"DocumentsPage_documents__Wh4s8","header":"DocumentsPage_header__9mHnv","btnPair":"DocumentsPage_btnPair__xXXfx","btn":"DocumentsPage_btn__0DBeh"};